import { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import toast from 'react-hot-toast'
import { Mail, Send, Loader2 } from 'lucide-react'
import { DARK, TEAL, BG, MarketingNavBar, MarketingFooter } from '../components/MarketingLayout'
import { sendContactMessage } from '../api/client'

export default function KapcsolatPage() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' })
  const [sending, setSending] = useState(false)
  const [sent, setSent] = useState(false)

  function set(k: keyof typeof form) {
    return (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      setForm(f => ({ ...f, [k]: e.target.value }))
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error('Add meg a neved, email címed és az üzeneted')
      return
    }
    setSending(true)
    try {
      await sendContactMessage(form)
      setSent(true)
    } catch (err: any) {
      toast.error('Hiba az üzenet küldésekor: ' + (err?.response?.data?.detail || err?.message || 'ismeretlen hiba'))
    } finally {
      setSending(false)
    }
  }

  return (
    <div style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>
      <Helmet>
        <title>Kapcsolat | CukrászDoc</title>
        <meta name="description" content="Kérdésed van a CukrászDoc-kal kapcsolatban? Írj emailt, vagy töltsd ki az űrlapot, és hamarosan válaszolunk." />
        <link rel="canonical" href="https://cukraszdoc.hu/kapcsolat" />
      </Helmet>
      <MarketingNavBar />

      <section style={{ background: `linear-gradient(160deg, ${DARK} 0%, #162119 100%)`, paddingTop: '5rem' }} className="relative overflow-hidden">
        <div className="relative max-w-3xl mx-auto px-6 py-16 lg:py-20">
          <h1 className="text-4xl sm:text-5xl font-bold leading-tight text-white mb-5">
            Kapcsolat
          </h1>
          <p className="text-lg max-w-2xl leading-relaxed" style={{ color: 'rgba(255,255,255,0.6)' }}>
            Kérdésed van, vagy segítségre van szükséged? Írj nekünk emailben, vagy töltsd ki az alábbi űrlapot — cukrász válaszol, nem ügyfélszolgálati sablon.
          </p>
          <a href="mailto:info@cukraszdoc.hu"
            className="inline-flex items-center gap-2 mt-6 text-base font-semibold"
            style={{ color: TEAL }}>
            <Mail size={18} /> info@cukraszdoc.hu
          </a>
        </div>
        <div className="relative" style={{ height: 60, marginBottom: -2 }}>
          <svg viewBox="0 0 1440 60" preserveAspectRatio="none" className="absolute bottom-0 w-full h-full">
            <path d="M0,30 C360,60 1080,0 1440,30 L1440,60 L0,60 Z" fill="#ffffff" />
          </svg>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-xl mx-auto px-6">
          {sent ? (
            <div className="rounded-2xl p-8 text-center" style={{ background: BG, border: '1px solid rgba(91,184,160,0.25)' }}>
              <p className="text-lg font-semibold mb-2" style={{ color: DARK }}>Köszönjük az üzeneted!</p>
              <p className="text-sm text-gray-500">Hamarosan válaszolunk a megadott email címre.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <div>
                <label className="text-sm font-medium mb-1.5 block" style={{ color: DARK }}>Név</label>
                <input className="input" value={form.name} onChange={set('name')} placeholder="Teljes név" />
              </div>
              <div>
                <label className="text-sm font-medium mb-1.5 block" style={{ color: DARK }}>Email cím</label>
                <input className="input" type="email" value={form.email} onChange={set('email')} placeholder="nev@email.hu" />
              </div>
              <div>
                <label className="text-sm font-medium mb-1.5 block" style={{ color: DARK }}>Telefonszám <span className="text-gray-400">(opcionális)</span></label>
                <input className="input" value={form.phone} onChange={set('phone')} placeholder="+36 30 123 4567" />
              </div>
              <div>
                <label className="text-sm font-medium mb-1.5 block" style={{ color: DARK }}>Üzenet</label>
                <textarea className="input" rows={5} value={form.message} onChange={set('message')} placeholder="Miben segíthetünk?" />
              </div>
              <button type="submit" disabled={sending}
                className="inline-flex items-center justify-center gap-2 mt-2 px-6 py-3 rounded-xl font-semibold text-base transition-opacity disabled:opacity-60"
                style={{ background: TEAL, color: '#fff' }}>
                {sending ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />}
                {sending ? 'Küldés...' : 'Üzenet elküldése'}
              </button>
            </form>
          )}
        </div>
      </section>

      <MarketingFooter />
    </div>
  )
}
